// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__(36956);
__webpack_require__(42059);
var __webpack_exports__ = __webpack_require__(5342);
